﻿window.cObjetDocCptMigreMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () {
        if (typeof objet.data == 'undefined') {
            return "Document comptable migré";
        } else {
            return this.mGetNomDocument()
        }
    }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau document comptable migré"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            txt = this.mGetNomDocument() + " " + this.mGetLibIdDocument()
            switch (parseInt(objet.data.id_statut_com)) {
                case 1:
                    txt += " " + this.mGetEtatHtml()
                    break;
                case 2:
                    if (objet.data.date_document != null) txt += " <span style='font-size:70%'>" + objet.data.date_document.toDDMMAA() + "&bull;" + objet.data.date_document.toHHMM() + "</span>"
                    txt += " " + this.mGetEtatHtml()

                    break;
            }
            return txt
        }
        else {
            txt = "Document comptable"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetEtatHtml = function () {
        var txt = ""
        switch (parseInt(objet.data.id_statut_com)) {
            case 1:
                txt = "<span style='color:" + theme.toastError + "'>Brouillon</span>"
                break;
            case 2:
                //if ((objet.data.id_type_com == "1" || objet.data.id_type_com == "2") && objet.data.id_doc_cpt_facture_valide != null) {
                //    txt = "<span style='color:" + theme.toastSuccess + "'>Soldé</span>"
                //} else {
                //if ((objet.data.id_type_com == "3" || objet.data.id_type_com == "5") && objet.data.reste_a_payer == 0) {
                if (objet.data.reste_a_payer == 0) {
                    txt += "<span style='color:" + theme.toastSuccess + "'>Soldé</span>"
                } else {
                    txt += "<span style='color:" + theme.toastWarning + "'>Validé</span>"
                }
                //}
                break;
        }
        return txt
    }

    this.mGetEtat = function () {
        var txt = ""
        switch (parseInt(objet.data.id_statut_com)) {
            case 1:
                txt = "Brouillon"
                break;
            case 2:
                if ((objet.data.id_type_com == "1" || objet.data.id_type_com == "2") && objet.data.id_doc_cpt_facture_valide != null) {
                    txt = "Soldé"
                } else {
                    if ((objet.data.id_type_com == "3" || objet.data.id_type_com == "5") && objet.data.reste_a_payer == 0) {
                        txt += "Soldé"
                    } else {
                        txt += "Validé"
                    }
                }
                break;
        }
        return txt
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetWidthPopup = function () {
        if ((objet.data.id_type_com == "4" || objet.data.id_type_com == "5") && objet.data.id_statut_com == "2") {
            return 540
        } else {
            if (objet.data.id_type_com == "5") { return 1000 }
            else { return 800 }
        }
    }
    this.mGetPaddingPopup = function () {
        return 20
    }

    this.mGetNomDocument = function () {
        var txt = ""
        switch (parseInt(objet.data.id_type_com)) {
            case 1: txt = "Devis"; break;
            case 2: txt = "Commande"; break;
            case 3: txt = "Facture"; break;
            case 4: txt = "Note"; break;
            case 5: txt = "Ticket"; break;
        }
        return txt
    }

    this.mGetLibIdDocument = function () {
        var txt = ""
        if (objet.data.id_document == null) {
            txt = "ID<sup style='font-size:60%'>(#" + objet.data.id_doc_cpt_migre + ")</sup>"
        } else {
            var entete = this.mGetEnteteNumDocument()
            txt = ((entete.length == 0) ? "N°" : entete) + objet.data.id_document
        }
        return txt
    }

    this.mGetUnUne = function () {
        var txt = ""
        switch (parseInt(objet.data.id_type_com)) {
            case 1: txt = "un"; break;
            case 2: txt = "une"; break;
            case 3: txt = "une"; break;
            case 4: txt = "un"; break;
            case 5: txt = "un"; break;
        }
        return txt
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        var toolTip = ""
        if (typeof dataTemplate == 'undefined') { $Icone = $("<i class='fafa fafa-file-invoice-euro'></i>"); }
        else {
            $Icone = $("<i class='fafa fafa-file-invoice-euro' style='position:relative;color:" + theme.color + ";'></i>");
            var txt = ""
            switch (parseInt(dataTemplate.id_type_com)) {
                case 1: txt = "D"; toolTip = "Devis"; break;
                case 2: txt = "C"; toolTip = "Commande"; break;
                case 3: txt = "F"; toolTip = "Facture"; break;
                case 4:
                    $Icone = $("<i class='fas fa-receipt' style='position:relative;color:" + theme.color + ";'></i>");
                    txt = "N";
                    toolTip = "Note";
                    break;
                case 5:
                    $Icone = $("<i class='fas fa-receipt' style='position:relative;color:" + theme.color + ";'></i>");
                    txt = "T";
                    toolTip = "Ticket";
                    break;
            }
            $("<div style='position:absolute;top:-2px;left:-2px;color:" + theme.backgroundcolorAccent + ";font-size:100%;font-family: fantasy;font-weight:100;'>" + txt + "</div>").appendTo($Icone)
            switch (parseInt(dataTemplate.id_statut_com)) {
                case 1: $("<i class='fas fa-pen' style='position:absolute;bottom:-2px;right:-3px;color:" + theme.backgroundcolorAccent + ";font-size:50%;'></i>").appendTo($Icone); break;
                case 2: $("<i class='fas fa-lock' style='position:absolute;bottom:-2px;right:-3px;color:" + theme.backgroundcolorAccent + ";font-size:50%;'></i>").appendTo($Icone); break;
            }
        }
        $Icone.attr("title", toolTip)
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text(toolTip) } })
        return $Icone
    }

    this.mShowPopup = function (optionPopup) {
        objet.bddRef.mAjaxCall({
            command: "getclientdoccptmigre",
            "id_doc_cpt_migre": objet.data.id_doc_cpt_migre
        }, function (data) {
            if (typeof data.id_table == 'undefined' || data.id_table == null) {
                mNotify("Ce document n'est lié à aucun contact dans votre base","warning",6000)
            } else {
                objet.bddRef.getObjet(objet.bddRef.table.mGetItem(data.id_table).nom,data.id).mShowPopup()
            }
        })
    }

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 73 : 53)
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var $TdUti = $("<td style='width:30px;padding:0 3px;height:1px;'/>")
        $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: ((dataTemplate.id_utilisateur == null) ? "" : objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1())
        })

        var $TdDest = $("<td style='width:40px;padding:0 3px;height:1px;position:relative;'/>")
        var $TdNomclient = null
        if (dataTemplate.id_table_client == null) {
            $("<div style='width:35px;height:35px;border-radius:50%;position:absolute;bottom:-5px;opacity:0.5;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                icon1: "fas fa-circle-question",
                text: ""
            })
        } else {
            $("<div style='width:35px;height:35px;border-radius:50%;position:absolute;bottom:-5px;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                icon1: "fas fa-portrait",
                icon2: "",
                idTable: dataTemplate.id_table_client,
                id: dataTemplate.id_client,
                dataTemplate: dataTemplate,
                text: dataTemplate.nom_client
            })
            //$TdNomclient = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:50%;' title='" + ((dataTemplate.nom_client == null) ? "(Aucun client)" : dataTemplate.nom_client) + "'>" + ((dataTemplate.nom_client == null) ? "(Aucun client)" : dataTemplate.nom_client) + "</td>")
        }
        var contenuClient = ((dataTemplate.id_table_client == null) ? "(Aucun client)" : ((dataTemplate.nom_client == null || dataTemplate.nom_client.length == 0) ? "CLIENT SANS NOM" : dataTemplate.nom_client)) + " &bull; <span style='" + ((dataTemplate.reste_a_payer > 0) ? "color:red" : ((dataTemplate.reste_a_payer < 0) ? "color:green" : "")) + "'>Reste à payer: " + parseFloat(dataTemplate.reste_a_payer).round().formatDisplay() + "€</span>"
        $TdNomclient = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:50%;'>" + contenuClient + "</td>")
        $TdNomclient.attr("title", contenuClient)

        var nomDocument = ""
        switch (parseInt(dataTemplate.id_type_com)) {
            case 1: nomDocument = "Devis"; break;
            case 2: nomDocument = "Commande"; break;
            case 3: nomDocument = "Facture"; break;
            case 4: nomDocument = "Note"; break;
            case 5: nomDocument = "Ticket"; break;
        }
        var $TdLibDoc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;' title='" + nomDocument + "'>" + nomDocument + "</td>")

        var txt = ""
        var toolTip = ""
        if (dataTemplate.id_document == null) {
            txt = "ID<sup style='font-size:60%'>(#" + dataTemplate.id_key + ")</sup>"
            toolTip = "ID#" + dataTemplate.id_key
        } else {
            var entete = ""
            switch (parseInt(dataTemplate.id_type_com)) {
                case 1: entete = dataTemplate.entete_devis; break;
                case 2: entete = dataTemplate.entete_commande; break;
                case 3: entete = dataTemplate.entete_facture; break;
                case 4: entete = dataTemplate.entete_recapitulatif; break;
                case 5: entete = dataTemplate.entete_ticket; break;
                default: entete = ""; break;
            }
            txt = ((entete.length == 0) ? "N°" : entete) + dataTemplate.id_document
            toolTip = txt
        }
        var $TdNumDoc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;' title='" + toolTip + "'>" + txt + "</td>")

        var txt = ""
        switch (parseInt(dataTemplate.id_statut_com)) {
            case 1:
                txt = "<span style='color:" + theme.toastError + "' title='Brouillon'>Brouillon</span>"
                break;
            case 2:
                if (dataTemplate.reste_a_payer <= 0) {
                    txt += "<span style='color:" + theme.toastSuccess + "' title='Soldé'>Soldé</span>"
                } else {
                    txt += "<span style='color:" + theme.toastWarning + "' title='Validé'>Validé</span>"
                }
                break;
        }
        var $TdEtatDoc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;'>" + txt + "</td>")

        var $TdHt = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;text-align:right;position:relative;'></td>")
        //var $TdTva = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:85px;text-align:right;'></td>").appendTo($Tr)
        var $TdTtc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;text-align:right;position:relative;'></td>")
        if (dataTemplate.assujetti_tva == "1") {
            $("<span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>HT</span>").appendTo($TdHt)
            $("<span title='HT: " + dataTemplate.totht_avec_remise_pied + "€'>" + parseFloat(dataTemplate.totht_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdHt)
            //$("<span><span class='dx-field-item-label-text' style='font-size:70%'>TVA:</span>" + parseFloat(dataTemplate.tottva_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdTva)
            $("<span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>TTC</span>").appendTo($TdTtc)
            $("<span title='TTC: " + dataTemplate.totttc_avec_remise_pied + "€'>" + parseFloat(dataTemplate.totttc_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdTtc)
        } else {
            $TdHt.css("display", "none")
            //$TdTva.css("display", "none")
            $TdTtc.css("width", "160px")
            $("<span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>Tot.Net TVA</span>").appendTo($TdTtc)
            $("<span title='Tot.Net TVA: " + dataTemplate.totttc_avec_remise_pied + "€'>" + parseFloat(dataTemplate.totttc_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdTtc)
        }
        if (parseFloat(dataTemplate.totttc_avec_remise_pied) < 0) $TdTtc.css("color", "red")

        if (type == "Lignes") {
            var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            $TdUti.appendTo($Tr)
            $TdDest.appendTo($Tr)
            $TdNomclient.appendTo($Tr)
            $TdLibDoc.appendTo($Tr)
            $TdNumDoc.appendTo($Tr)
            $TdEtatDoc.appendTo($Tr)
            $TdHt.appendTo($Tr)
            $TdTtc.appendTo($Tr)
        } else {
            var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            $TdUti.appendTo($Tr)
            $TdDest.appendTo($Tr)
            $TdNomclient.appendTo($Tr); $TdNomclient.css("width", "100%")

            var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            $("<td style='width:25%'/>").appendTo($Tr)
            $TdLibDoc.appendTo($Tr); $TdLibDoc.css("width", "15%");
            $TdNumDoc.appendTo($Tr); $TdNumDoc.css("width", "15%");
            $TdEtatDoc.appendTo($Tr); $TdEtatDoc.css("width", "15%");
            $TdHt.appendTo($Tr); $TdHt.css("width", "15%");
            $TdTtc.appendTo($Tr); $TdTtc.css("width", "15%");
        }

        objet.bddRef.mAjaxCall({
            command: "getlignedoccptmigre",
            id_doc_cpt_migre: dataTemplate.id_doc_cpt_migre
        }, function (data) {
            if (typeof data.lst_ligne == 'undefined') data.lst_ligne = []
            if (data.lst_ligne.length > 0) {
                var $Div = $("<div style='text-align:right;padding-top:5px;'/>").appendTo(contentElement)
                var $Div = $("<div style='display:inline-block;;width:70%;' />").appendTo($Div)
                var $Table = $("<table style='width:100%;font-family:barlow condensed;table-layout:fixed;opacity:0.7;font-size:90%;'/>").appendTo($Div)
                data.lst_ligne.forEach(function (lig) {
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='overflow:hidden;text-overflow:ellipsis;width:100%;border-top:" + theme.border + ";'/>").appendTo($Tr).text(lig.nom)
                    var color = ""
                    if (parseFloat(lig.totttc_avec_remise_pied) < 0) color = 'color:red;'
                    var $Td = $("<td style='width:30px;" + color + "border-top:" + theme.border + ";'/>").appendTo($Tr).html("<span style='font-size:70%;opacity:0.57;'>Qté:</span>" + lig.qte)
                    var $Td = $("<td style='white-space:nowrap;text-align:right;width:60px;" + color + ";border-top:" + theme.border + ";'/>").appendTo($Tr).html("<span style='font-size:70%;opacity:0.7;'>HT:</span>" + parseFloat(lig.totht_avec_remise_pied).formatDisplay() + "€")
                    //var $Td = $("<td style='white-space:nowrap;text-align:right;width:60px;" + color + ";border-top:" + theme.border + ";'/>").appendTo($Tr).html("<span style='opacity:0.6;'>" + parseFloat(lig.tottva_avec_remise_pied).formatDisplay() + "€</span>")
                    var $Td = $("<td style='white-space:nowrap;text-align:right;width:60px;" + color + ";border-top:" + theme.border + ";'/>").appendTo($Tr).html("<span style='font-size:70%;opacity:0.7;'>TTC:</span>" + parseFloat(lig.totttc_avec_remise_pied).formatDisplay() + "€")
                })
            }
        })

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        if (dataPlus.date_document == null) {
            $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        } else {
            $("<span style='' title='Validé le " + dataPlus.date_document.toFrenchDateTime() + "'><i class='fafa fafa-file-invoice-euro dx-theme-accent-as-text-color' style='padding-right:3px;'></i><b>" + dataPlus.date_document.toDateIlya(true) + "</b></span>").appendTo(contentElement)
        }
    }

}